import RowRateFilter from '../RowRateFilter'
import TableList from '../TableList'

export default function RecommendedDSC() {
    const data: any = [];

    return (
        <>
            <div className='dpdhtfntlz'>
                <div className='rvtheozjaa'>
                    <TableList data={data} />
                </div>
            </div>
        </>
    )
}